import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

export type AccountType =
  | 'alpha_pending'
  | 'alpha_guest'
  | 'alpha_member'
  | 'alpha_admin'
  | 'alpha_deactivated';

export function getAccountType(state: RootState): AccountType {
  return state.map3Data.userProfile?.accountType as AccountType;
}

// Optional: Add a React hook version for convenience
export function useAccountType(): AccountType {
  return useSelector((state: RootState) => getAccountType(state));
}
